import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import moment from 'moment/moment';
import { getLessons } from '../../store/actions';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatMonth } from '../../data/format-month';
import { base } from '../../store/api';

const BlogSidebar = (props) => {
    const {t} = useTranslation()
    const [lessons, setLessons] = useState([])
    const dispatch = useDispatch()
    const language = localStorage.getItem('i18nextLng')

    const formatDate = (date) => {
        const month = date.split("T")[0].split("-")[1]
        return `${formatMonth(month, language)} ${moment(date).format(`DD, YYYY`)}`
    }

    useEffect(() => {
        const lang = language === 'tm' ? 'tk' : language
        let params = {
            limit : 6,
            offset : 0
        }
        getLessons(dispatch, params, lang, (err, res) => {
        if(err) console.log(err);
        setLessons(res?.results)
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[language])

    return (
        <div className="sidebar-widget-wrapper">
            <div className="sidebar__widget mb-30">
                <div className="sidebar__widget-head mb-35">
                    <h4 className="sidebar__widget-title">{t("other_lessons")}</h4>
                </div>
                <div className="sidebar__widget-content">
                    <div className="rc__post-wrapper">
                      {
                        Array.isArray(lessons) && lessons.length > 0 && lessons.map((item) => {
                          return (
                            <Link
                              key={item.id}
                              to={`/lesson-details/${item.id}`}>
                              <div className="tw-my-3 tw-flex tw-items-center tw-gap-1.5">
                                <div className="tw-basis-1/2 tw-aspect-[3/2] tw-bg-sky-100">
                                  {item.thumbnail &&
                                    <img src={`${base}${item.thumbnail}`}
                                         className="tw-w-full tw-aspect-[3/2] tw-object-contain"
                                         alt="img not found" />}
                                </div>
                                <div className="tw-basis-1/2 rc__content">
                                  <div className="rc__meta">
                                    <span className="tw-capitalize">{formatDate(item.created_at)}</span>
                                  </div>
                                  <h6 className="rc__title">
                                    {item.title}
                                  </h6>
                                </div>
                              </div>
                            </Link>
                          );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogSidebar;